export default __webpack_public_path__ + "static/logo-80a6f407a4b804e3e72838a032aabcb5.svg";